<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @before-open="beforeOpen"
    >
    </avue-crud>
  </div>
</template>

<script>
    import crudMixins from "@/mixins/crud-mixins";
    import {getList, add, update, remove, getDetail} from "./api";
    import {searchTimeConfig} from "@/basic-common/util/common";
    //import { getMonthStartTime, getTodayEndTime } from "@/util/date.js";

    export default {
        name: "device-parameter/index",
        mixins: [crudMixins],
        data() {
            return {
                apiConfig: {getList, add, update, remove, getDetail},
                infoCardData: [], // 卡片数据
                option: {
                    ...this.$store.state.publicOption,
                    menu: true,
                    addBtn: true,
                    delBtn: false,
                    editBtn: true,
                    viewBtn: true,
                    dialogWidth: "600px",
                    dialogHeight: "400px",
                    column: [
                        {
                            label: '设备id',
                            prop: 'baseDeviceId',
                        },
                        {
                            label: '设备分类',
                            prop: 'category',
                        },
                        {
                            label: '设备类型',
                            prop: 'deviceType',
                        },
                        {
                            label: "设备名称",
                            prop: "deviceName",
                            width: 150,
                            overHidden: true,
                            search: true,
                            type: "input",
                            searchPlaceholder: "请输入设备名称",
                            addDisplay: true,
                            editDisplay: true,
                            viewDisplay: true,
                            rules: [
                                {required: true, message: "请输入设备名称", trigger: "blur"},
                                {
                                    min: 1,
                                    max: 50,
                                    message: "设备名称长度在1到50个字符",
                                    trigger: "blur",
                                },
                            ],
                        },
                        {
                            label: '参数值',
                            prop: 'parameterValue',
                        },
                        {
                            label: '下限',
                            prop: 'normalMin',
                        },
                        {
                            label: '上限',
                            prop: 'normalMax',
                        },
                        {
                            label: '提醒类型',
                            prop: 'alertType',
                        },
                        {
                            label: '类型',
                            prop: 'type',
                        },
                        {
                            label: '处理机制',
                            prop: 'handlingMechanism',
                        },
                        {
                            label: '备注',
                            prop: 'remark',
                        },
                        {
                            label: '创建人ID',
                            prop: 'createUser',
                        },
                        {
                            label: "创建人",
                            prop: "createName",
                            align: "center",
                            width: 100,
                            addDisplay: false,
                            editDisplay: false,
                            viewDisplay: true,
                        },
                        {
                            label: '创建时间',
                            prop: 'createTime',
                            type: 'datetime',
                            format: 'yyyy-MM-dd HH:mm:ss',
                            valueFormat: 'yyyy-MM-dd HH:mm:ss',
                            minWidth: 120,
                        },
                        {
                            label: '1=有效',
                            prop: 'status',
                        },
                        {
                            ...searchTimeConfig,
                            paramsKey: ["startTime", "endTime"],
                        },
                    ]
                },
            }
        }
    }
</script>
<style scoped lang="scss">
</style>
